module.exports = __webpack_public_path__ + "img/logo5-blue-white-gold.04479b28.svg";